import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-collections-list',
    templateUrl: './collections-list.component.html',
    styleUrls: ['./collections-list.component.scss'],
})
export class CollectionsListComponent implements OnDestroy {
    destroy$ = new Subject();

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
